module.exports = __webpack_public_path__ + "img/shoerackA11.ec9aca58.jpg";